import App from './App.svelte';

const app = new App({
	target: document.querySelector("#root"),
	props: {
		name: 'world'
	}
});

export default app;